import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation, Trans } from 'react-i18next';

function PrivacyPolicyModal({ show, handleClose }) {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      contentClassName="border-0"
      size="lg"
    >
      <Modal.Header className="pt-3 pb-4 app-txt-granite border-0 shadow-none" closeButton>
        {/* <Modal.Title className="mx-auto">
          <p className="mb-0 app-txt-red">Aviso</p>
        </Modal.Title> */}
      </Modal.Header>
      <Modal.Body className="lh-sm overflow-auto" style={{ height: '500px' }}>
        <p className="app-fw-figtree-bold app-txt-granite-80"><Trans i18nKey="PRIVACY_POLICY:TXT_TITLE" /></p>
        <div className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_DESCRIPTION" /></div>

        <p className="app-fw-figtree-bold app-txt-granite-80"><Trans i18nKey="PRIVACY_POLICY:TXT_RESPONSIBLE_TITLE" /></p>
        <div className="app-txt-granite-80-dark">
          <Trans i18nKey="PRIVACY_POLICY:TXT_RESPONSIBLE_DESCRIPTION" />
        </div>
        <ul>
          <li className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_RESPONSIBLE_DESCRIPTION_1" /></li>
          <li className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_RESPONSIBLE_DESCRIPTION_2" /></li>
          <li className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_RESPONSIBLE_DESCRIPTION_3" /></li>
        </ul>
        <p className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_RESPONSIBLE_DESCRIPTION_4" /></p>
        <p className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_RESPONSIBLE_DESCRIPTION_5" /></p>

        <p className="app-fw-figtree-bold app-txt-granite-80"><Trans i18nKey="PRIVACY_POLICY:TXT_PERSONAL_DATA_COLLECT_TITLE" /></p>
        <Trans i18nKey="PRIVACY_POLICY:TXT_PERSONAL_DATA_COLLECT_DESCRIPTION" />
        <ul>
          <li className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_PERSONAL_DATA_COLLECT_DESCRIPTION_1" /></li>
          <li className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_PERSONAL_DATA_COLLECT_DESCRIPTION_2" /></li>
          <li className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_PERSONAL_DATA_COLLECT_DESCRIPTION_3" /></li>
        </ul>

        <p className="app-fw-figtree-bold app-txt-granite-80"><Trans i18nKey="PRIVACY_POLICY:TXT_DATA_LEGAL_BASIS_TITLE" /></p>
        <div className="app-txt-granite-80-dark">
          <Trans i18nKey="PRIVACY_POLICY:TXT_DATA_LEGAL_BASIS_DESCRIPTION" />
        </div>

        <p className="app-fw-figtree-bold app-txt-granite-80"><Trans i18nKey="PRIVACY_POLICY:TXT_DATA_COMMUNICATE_TITLE" /></p>
        <div className="app-txt-granite-80-dark">
          <Trans i18nKey="PRIVACY_POLICY:TXT_DATA_COMMUNICATE_DESCRIPTION" />
        </div>
        <ul>
          <li className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_DATA_COMMUNICATE_DESCRIPTION_1" /></li>
          <li className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_DATA_COMMUNICATE_DESCRIPTION_2" /></li>
          <li className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_DATA_COMMUNICATE_DESCRIPTION_3" /></li>
          <li className="app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_DATA_COMMUNICATE_DESCRIPTION_4" /></li>
        </ul>

        <p className="app-fw-figtree-bold app-txt-granite-80"><Trans i18nKey="PRIVACY_POLICY:TXT_DATA_KEEP_TITLE" /></p>
        <div className="app-txt-granite-80-dark">
          <Trans i18nKey="PRIVACY_POLICY:TXT_DATA_KEEP_DESCRIPTION" />
        </div>

        <p className="app-fw-figtree-bold app-txt-granite-80"><Trans i18nKey="PRIVACY_POLICY:TXT_YOUR_RIGHTS_TITLE" /></p>
        <div className="app-txt-granite-80-dark">
          <Trans i18nKey="PRIVACY_POLICY:TXT_YOUR_RIGHTS_DESCRIPTION" />
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 d-block">
        <p className="app-fs-12 app-txt-granite-80-dark"><Trans i18nKey="PRIVACY_POLICY:TXT_PREPARED_ACCORDANCE_LAW" /></p>
        <div className="text-center">
          <Button
            variant=""
            onClick={handleClose}
            // className="app-bg-red text-white app-fw-figtree-bold py-2 px-4 rounded-3 btn-height"
            className="app-bg-sand app-fw-notosans-bold app-txt-granite rounded-3 btn-height border-0"
          >
            {t('TXT_BOTON_CONTINUE')}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default PrivacyPolicyModal;
